import { render, staticRenderFns } from "./CoursePromotionGroupTagAdd.vue?vue&type=template&id=c3280fbe&scoped=true"
import script from "./CoursePromotionGroupTagAdd.vue?vue&type=script&lang=js"
export * from "./CoursePromotionGroupTagAdd.vue?vue&type=script&lang=js"
import style0 from "./CoursePromotionGroupTagAdd.vue?vue&type=style&index=0&id=c3280fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3280fbe",
  null
  
)

export default component.exports